import React, { useCallback } from 'react';
import { Field } from '@ontruck/orc';
import styled from 'styled-components';

const StyledField = styled(Field)`
  & > input {
    height: 100%;
  }
`;

const t = {
  label: 'Postal code',
};

const PostalCodeFilter = ({ value, handleChangeFilter }) => {
  const handleChange = useCallback(
    (_, { value }) => {
      if (!value) {
        handleChangeFilter('postalcode')('');
      }

      handleChangeFilter('postalcode')(value.toString());
    },
    [handleChangeFilter]
  );

  return <StyledField label={t.label} value={value || ''} onChange={handleChange} width="M" />;
};

export default PostalCodeFilter;
